import {Component, OnInit, ViewChild} from "@angular/core";
import {FormBuilder, FormGroup, Validators, FormControl} from "@angular/forms";
import { Observable, throwError } from 'rxjs';
import {ConfigService} from "app/Core/Abstract/config.service";
import { VisualsService } from 'app/Core/Abstract/visuals.service';
import {EventsEmitterService} from "app/Core/Abstract/emitter.service";
import {PasswordValidatorOptions, passwordValidator} from "app/Core/Login/passwordValidator.component";
import {RegisterService} from "app/Core/Register/register.service";
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ActivatedRoute , Router } from "@angular/router";
import { LogService } from "app/Core/Abstract/log.service";
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
    selector: 'onboarded',
    templateUrl: 'onboarded.component.html',
    providers: [RegisterService]
})

export class OnBoardedComponent implements OnInit {
    @ViewChild('msgModal',{static: false}) public msgModal: ModalDirective;
    
    userModal
    /*
     *  Modal handling
     */

    public showChildModal(): void {
        this.msgModal.show();
    }

    public hideChildModal(): void {
        this.msgModal.hide();
    }

    public email =  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    protected redirectTitle = "";
    protected redirectMsg = "";
    private token: String;
    private loading: boolean = false;
    genOtp: boolean;
    private pwdmodel:any;  
    termsFromServer: any;  
    showSuccessMessage=false;
    private validateTokenHasError:boolean = false;
    countryList = [];
    submittingClientForm: boolean;
    loadingDocTerms: any;
    otpMessage: any;
    docTerms: any
    private pwdForm: FormGroup;
    vatIssueCountry: any;
    private validationMessages= {};
    private formErrors = {
        'username': 'This is not valid username',
        'tradel': '',
        'bankacc': '',
        'otp': '',
        'country': ''
    };
    lang:any = 2;

    pwderror = false;
    pwdmsg = "";
    public barLabel: string = "";

    constructor(private registerService: RegisterService, private fb: FormBuilder,private router: Router,
                private configService: ConfigService, private eventsEmitterService :EventsEmitterService, protected route: ActivatedRoute,
                protected visualsService: VisualsService) {
        this.pwdmodel = {
            country:""
        };  
    }

    ngOnInit(): void {
        this.route.queryParams.subscribe(
            params => {
                this.token = params.token;
            },
            error => {
               return throwError(error);
            }
        );
        this.validateToken()
        this.buildForm();
        this.getCountryList();
    }

    getCountryList(){
        this.registerService.getCountryList("1")
        .subscribe(
          data => {
              this.countryList = data;
              this.loading = false;
          },
          error => {
            this.loading = false;
          }
        );
    }

    checkCountry(){
        this.registerService.checkCountryBytoken(this.token)
        .subscribe(
          res => {
              this.vatIssueCountry = res;
              this.loading = false;
          },
          error => {
            this.loading = false;
          }
        );
    }

    validateToken(){
        this.loading = true;
        this.registerService.validateToken(this.token).subscribe(
            data => {
                if(data == 'expired'){
                    this.loading = false;
                    this.validateTokenHasError = true
                    this.redirectTitle = 'Your token has expired';
                    this.redirectMsg = 'Resend Verification Mail!';
                    this.showChildModal();
                }
               else if(data == 'invalidToken'){ 
                this.loading = false;
                this.validateTokenHasError = true
                this.redirectTitle = 'Your token is invalid';
                this.redirectMsg = 'Your token is invalid'
                this.showChildModal();
               }
               else if(data == 'valid'){ 
                this.checkCountry();
               }
            },
            error => {
                this.validateTokenHasError = true;
                this.redirectTitle = 'Something went wrong.';
                this.redirectMsg = ''
                this.loading = false;
            }
        );
    }
   
    private buildForm() {
        this.pwdForm = new FormGroup({
            'username': new FormControl(this.pwdmodel.username, [Validators.required]),
            'tradel': new FormControl(this.pwdmodel.tradel, [Validators.required]),
            'bankacc': new FormControl(this.pwdmodel.bankacc, [Validators.required]),
            'country': new FormControl(this.pwdmodel.country, [Validators.required]),
            'otp' : new FormControl(this.pwdmodel.otp, [Validators.required])
        })
    }
    hideSuccessMessage(){
        this.showSuccessMessage = false;
    }

    public generateOtp(){
        this.genOtp = true

        if(this.pwdForm.controls['username'].valid){    
            this.registerService.generateOtp(this.pwdForm.value, this.token).subscribe(
                data => {
                    this.showSuccessMessage = true;
                    this.otpMessage = "We have sent an SMS to your registered mobile number containing authentication code."
                },
                error => {
                    this.showSuccessMessage = false;
                    this.loading = false;
                    return Observable.throw(error);
                }
            );
        }
    }

    public submitClientForm(){
        this.submittingClientForm = true
        if(!this.pwdForm.valid ){
            return
        }
         this.registerService.submitClientForm(this.pwdForm.value,this.token).subscribe(
            data => {
                this.submittingClientForm = false
                this.genOtp = false
                this.pwdForm.reset()
                LogService.emitAlert({
                    type: "success",
                    body: data.message
                    });
                this.router.navigateByUrl('login');
            },
            error => {
                this.submittingClientForm = false
                this.genOtp = false
                this.loading = false;
                return Observable.throw(error);
            }
        );
    }
}